import { render, staticRenderFns } from "./SynAntoNyms.vue?vue&type=template&id=1d457591&scoped=true&"
import script from "./SynAntoNyms.vue?vue&type=script&lang=js&"
export * from "./SynAntoNyms.vue?vue&type=script&lang=js&"
import style0 from "./SynAntoNyms.vue?vue&type=style&index=0&id=1d457591&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d457591",
  null
  
)

component.options.__file = "SynAntoNyms.vue"
export default component.exports